var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvg6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 16.8,
    viewBox: "0 0 12 16.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5481",
    "data-name": "Rectangle 5481",
    width: 12,
    height: 16.8,
    fill: "#7dab3c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9596",
    "data-name": "Group 9596",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29905",
    "data-name": "Path 29905",
    d: "M3,16.8v-.22Q3,15.39,3,14.2c0-.3-.1-.4-.406-.4H0v-.207Q0,7.014,0,.434C0,.087.085,0,.428,0H11.581C11.91,0,12,.091,12,.425Q12,8.4,12,16.377c0,.332-.09.423-.421.423H3M4.8,2.7c-.5,0-.969,0-1.443,0C3.111,2.7,3,2.81,3,3.055c0,.381-.023.764.009,1.143a2.357,2.357,0,0,0,.2.57.851.851,0,0,1,.088.249c.008.5,0,1,0,1.5,0,.281.1.382.386.383H8.317c.28,0,.382-.1.383-.386,0-.5,0-1,0-1.5a.418.418,0,0,1,.082-.232A.967.967,0,0,0,9,4.177c0-.369,0-.737,0-1.106C9,2.8,8.892,2.7,8.62,2.7c-.412,0-.825,0-1.237,0H7.2c0-.305,0-.58,0-.855A.305.305,0,0,0,6.851,1.5Q6,1.5,5.144,1.5a.3.3,0,0,0-.344.348c0,.274,0,.549,0,.851M6.619,8.1H3.431a.833.833,0,0,0-.187.008.3.3,0,0,0,0,.584.811.811,0,0,0,.187.008H9.768a.918.918,0,0,0,.168,0,.3.3,0,0,0,0-.59.937.937,0,0,0-.168,0H6.619m0,1.8H3.431a.835.835,0,0,0-.187.008.3.3,0,0,0,0,.584.814.814,0,0,0,.187.008H9.768a.923.923,0,0,0,.168,0,.3.3,0,0,0,0-.59.933.933,0,0,0-.168,0H6.619m0,1.8H3.431a.937.937,0,0,0-.168,0,.3.3,0,0,0,0,.59.914.914,0,0,0,.168,0H9.768a.923.923,0,0,0,.168,0,.3.3,0,0,0,0-.59.932.932,0,0,0-.168,0H6.619M2.092,8.1a.3.3,0,1,0,.306.287A.3.3,0,0,0,2.092,8.1M2.4,10.2a.3.3,0,1,0-.294.3.3.3,0,0,0,.294-.3m0,1.791a.3.3,0,1,0-.285.309A.3.3,0,0,0,2.4,11.99",
    transform: "translate(0 0)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29906",
    "data-name": "Path 29906",
    d: "M6.858,289.9l-2.151-2.151H6.858Z",
    transform: "translate(-4.471 -273.331)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29907",
    "data-name": "Path 29907",
    d: "M73.346,67.292c-.421,0-.82.006-1.218,0a.269.269,0,0,1-.277-.276c-.011-.3,0-.6,0-.908h4.8c0,.307.008.611,0,.915a.263.263,0,0,1-.265.267c-.4.011-.808,0-1.229,0,0-.09,0-.163,0-.236,0-.254-.111-.359-.37-.361q-.534,0-1.068,0c-.255,0-.358.109-.362.368,0,.068,0,.137,0,.229",
    transform: "translate(-68.246 -62.794)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29908",
    "data-name": "Path 29908",
    d: "M82.209,103.163H78.032v-1.177h1.191c0,.091,0,.183,0,.274a.293.293,0,0,0,.305.31q.59.009,1.181,0a.3.3,0,0,0,.312-.323c0-.086,0-.172,0-.266h1.187Z",
    transform: "translate(-74.123 -96.872)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5479",
    "data-name": "Rectangle 5479",
    width: 1.18,
    height: 0.577,
    transform: "translate(5.412 2.11)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5480",
    "data-name": "Rectangle 5480",
    width: 0.579,
    height: 0.582,
    transform: "translate(5.709 4.507)",
    fill: "#7dab3c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg6);
export default __webpack_public_path__ + "static/media/svg6.eb2ba60baff26c2ef10903ce3e416c90.svg";
export { ForwardRef as ReactComponent };